import _slicedToArray from "/builds/1TgzPVrG/0/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState } from "react";
import productsConfig from "./config";
import { ProductsList, ProductsListHeader } from "./ProductsList";
import { ProductsListEmpty } from "./ProductsListEmpty";
import * as S from "./styles";
export function Products(_ref) {
  var _ref$source = _ref.source,
      t = _ref$source === void 0 ? "taker" : _ref$source,
      e = _ref.productsList,
      r = _ref.isQuotaFull,
      a = _ref.truncationStrategy,
      o = _ref.sanitationStrategy,
      c = _ref.onClick,
      n = _ref.onCancel;

  var _useState = useState(!1),
      _useState2 = _slicedToArray(_useState, 2),
      s = _useState2[0],
      i = _useState2[1],
      u = 0 === (null == e ? void 0 : e.length);

  return React.createElement(React.Fragment, null, r ? React.createElement(ProductsListEmpty, {
    testId: "full-quota-view",
    content: "Sorry, there are no tests available for you to claim."
  }) : u ? React.createElement(ProductsListEmpty, {
    testId: "empty-tests-view",
    content: "There are no tests available to you at this moment. Please check with your\n        organization if this is an error."
  }) : React.createElement(React.Fragment, null, React.createElement(ProductsListHeader, {
    source: t
  }), React.createElement(ProductsList, {
    productsList: e,
    truncationStrategy: a,
    sanitationStrategy: o
  })), React.createElement(S.ProductsButtonGroup, {
    reverse: !0
  }, React.createElement(S.PrimaryButton, {
    hasArrow: !0,
    source: t,
    appearance: "primary",
    isLoading: s,
    onClick: function onClick(t) {
      i(!0), c && c(t);
    },
    disabled: u || r
  }, productsConfig[t].button.text), n && React.createElement(S.SecondaryButton, {
    onClick: n,
    appearance: "secondary"
  }, "Cancel")));
}
export default Products;